'use client';

import React, { createContext, useContext } from 'react';
import { useGetIndustriesQuery, useGetCustomizationTypesQuery } from '../../../../../../store/services/lookups';

interface LookupItem {
  id: string;
  code: string;
  name: string;
}

// interface CurrencyItem {
//   id: string;
//   code: string;
//   name: string;
// }

interface IndustryItem {
  id: string;
  code: string;
  name: string;
  icon: string;
}

interface AddProductLookupsContextValue {
  // currencies: CurrencyItem[];
  // currenciesLoading: boolean;
  industries: IndustryItem[];
  industriesLoading: boolean;
  customizationTypes: LookupItem[];
  customizationTypesLoading: boolean;
}

const AddProductLookupsContext = createContext<AddProductLookupsContextValue | null>(null);

export const AddProductLookupsProvider = ({ children }: { children: React.ReactNode }) => {
  // const { data: currenciesData, isLoading: currenciesLoading } = useGetCurrenciesPreferenceQuery();

  const { data: industriesData, isLoading: industriesLoading } = useGetIndustriesQuery();

  const { data: customizationTypesData, isLoading: customizationTypesLoading } = useGetCustomizationTypesQuery();

  return (
    <AddProductLookupsContext.Provider
      value={{
        // currencies: currenciesData ?? [],
        // currenciesLoading,
        industries: industriesData ?? [],
        industriesLoading,
        customizationTypes: customizationTypesData ?? [],
        customizationTypesLoading,
      }}
    >
      {children}
    </AddProductLookupsContext.Provider>
  );
};

export const useAddProductLookups = (): AddProductLookupsContextValue => {
  const context = useContext(AddProductLookupsContext);
  if (!context) {
    throw new Error('useAddProductLookups must be used within AddProductLookupsProvider');
  }
  return context;
};
